module.exports = __webpack_public_path__ + "static/FirstTeam-c80f1b8b345e9b6018661486296337fd.webp";